import React, {useState, useEffect} from 'react';
// import { UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { AiOutlineSetting} from "react-icons/ai";  
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showUpdProj } from '../redux/ctrl/ctrlActions';
import '../pkgs/index.scss';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { RiFileInfoLine } from "react-icons/ri";
import { MdOutlineLockPerson } from "react-icons/md";
const SettingsMenu = () => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const { t, i18n } = useTranslation();
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const ctrlState = useSelector((state) => state.ctrl);
    // const history = useHistory();
    const navigate = useNavigate();
    const dispatch= useDispatch();
    const navProjInfo = () => {
        ctrlState.updProj = true;
        dispatch(showUpdProj(ctrlState))
    };
    const profileState = useSelector((state) => state.profile);
    let chkAcc = profileState.capb.findIndex(o=> o.PWSASNPR === 'Y')>=0 ?  true : false;
    const updata = useSelector(state => state.prjasn.projectsAsn);
    const [writeAcc, setWriteAcc] = useState()
    useEffect(() => {
        let write_accs = updata?.filter((item)=>item.project_id === ctrlState.data?.project_id && profileState.email?.toLowerCase() === item.email_id?.toLowerCase())[0]?.write_access;
        write_accs = ctrlState.data.created_by?.toLowerCase() === profileState.email?.toLowerCase() || write_accs == "Y"? true : false;
            if (!write_accs) {
                write_accs =(profileState.capb.findIndex((o)=> o.PWSADACC === 'Y') >= 0 ?true : false);
            }
        setWriteAcc(write_accs);
      }, [updata, ctrlState.data]);
    
    return (
        <>
            <Button
                id="projectSettings"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <label><AiOutlineSetting className="settingsbtn" data-toggle="tooltip" data-placement="top" title={t('Settings')} /></label>
            </Button>
            <Menu
                id='profilesettings'
               // className="scrollable-menu"
                anchorEl={anchorEl}
                open={open}
                //anchorOrigin={{vertical: 'top',horizontal: 'right',}}
                //transformOrigin={{vertical: 'top',horizontal: 'right',}}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem className="settingsbtn cmnlblfnt font-14 cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => { navProjInfo(); handleClose(); }}><RiFileInfoLine style={{marginRight: '5px', fontSize: '14px'}}/> {t('Project Info')}  </MenuItem>
                {(chkAcc && writeAcc) && !window.location.href.includes('permissions') && <MenuItem className="settingsbtn cmnlblfnt font-14 cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => { navigate('/permissions') }}><MdOutlineLockPerson style={{marginRight: '5px', fontSize: '14px'}}/> {t('Permissions')} </MenuItem>}

            </Menu>
        </>
    )
}

export default SettingsMenu;